import styled, { css } from 'styled-components'
import { FlagProps } from '.'

export const Wrapper = styled.div<FlagProps>`
  background-color: ${(props) => props.backgroundColor};
  height: 32px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Label = styled.span`
  font-size: 14px;
  padding: 10px;
  ${({ theme }) => css`
    color: ${theme.colors.darkGray};
  `}
`
